import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref, useContext } from '@nuxtjs/composition-api';
import { ACTIONS as SIDEBAR_ACTIONS, GETTERS as SIDEBAR_GETTERS } from '~/store/affility/user/notifications/sidebar/names';
import { ACTIONS as HISTORY_ACTIONS, GETTERS as HISTORY_GETTERS } from '~/store/affility/user/notifications/history/names';
import { ACTIONS as UNREAD_ACTIONS, GETTERS as UNREAD_GETTERS } from '~/store/affility/user/notifications/unread/names';
import { getClientRuntimeConfig } from '~/core/helpers/GlobalHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  setup(__props) {

const { store } = useContext();

const isSidebarOpen = computed(() => store.getters[`affility/user/notifications/sidebar/${SIDEBAR_GETTERS.NOTIFICATIONS_BAR_OPEN}`]);
const totalNotificationsCount = computed(() => store.getters[`affility/user/notifications/history/${HISTORY_GETTERS.TOTAL_NOTIFICATIONS_COUNT}`]);
const unreadNotifications = computed(() => store.getters[`affility/user/notifications/unread/${UNREAD_GETTERS.UNREAD_NOTIFICATIONS}`]);
const readNotifications = computed(() => store.getters[`affility/user/notifications/history/${HISTORY_GETTERS.NOTIFICATION_HISTORY}`]);

const closeSidebar = store.dispatch.bind(null, `affility/user/notifications/sidebar/${SIDEBAR_ACTIONS.CLOSE_NOTIFICATIONS_BAR_AND_READ}`);
const loadNotificationsHistory = store.dispatch.bind(null, `affility/user/notifications/history/${HISTORY_ACTIONS.LOAD_MORE_NOTIFICATIONS_HISTORY}`);
const notificationsHistoryLoading = computed(() => store.getters[`affility/user/notifications/history/${HISTORY_GETTERS.NOTIFICATIONS_HISTORY_LOADING}`]);
const notificationsHistoryLoadingError = computed(() => store.getters[`affility/user/notifications/history/${HISTORY_GETTERS.NOTIFICATIONS_HISTORY_LOADING_ERROR}`]);
const $config = getClientRuntimeConfig();
const isXmasMode = computed(() => $config.xmasMode);
const notificationsList = ref<HTMLDivElement>(null);
const topButtonVisible = ref(false);
const onScroll = (event: Event) => {
    const target = event.target as HTMLElement;
    topButtonVisible.value = target.scrollTop > 0;
    if (target.scrollTop + target.clientHeight  >= target.scrollHeight && !notificationsHistoryLoadingError.value) {
        loadNotificationsHistory();
    }
};
const jumpToTop = () => {
    if (notificationsList.value) {
        notificationsList.value.scrollTo({ top: 0, behavior: 'smooth' });
    }
};


onUnmounted(() => {
    closeSidebar();
});

return { __sfc: true,store, isSidebarOpen, totalNotificationsCount, unreadNotifications, readNotifications, closeSidebar, loadNotificationsHistory, notificationsHistoryLoading, notificationsHistoryLoadingError, $config, isXmasMode, notificationsList, topButtonVisible, onScroll, jumpToTop }
}

})